import {SWITCH_DARKMODE} from '../constants/actionTypes';

export function switchDarkmode() {
    return {
        type: SWITCH_DARKMODE,
    };
}
